/** @module Browser entry point: mounts the app into #root. */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { api } from "@/api/client";
import { App } from "@/app/app";
import { setLogTransport } from "@/lib/client-log";
import { reportUncaughtErrors } from "@/lib/error-report";
// Self-hosted fonts: the CSP allows no third-party font hosts (SIL OFL, see docs/FRONTEND.md).
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/instrument-sans";
import "@fontsource-variable/jetbrains-mono";
import "@/styles/index.css";

// Diagnostics from the phone end up in the server log; see lib/client-log.ts.
setLogTransport((entries, screen) =>
  api.POST("/api/v1/client-logs", { body: { entries, screen } }),
);
reportUncaughtErrors();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
